
function id () {
	return (new Date()).getTime().toString(32)
}

export default id